import { createAction, createErrorAction } from '../../actions/actionCreator';
import { Operations, GenericFilters, ActionsType } from '@card/types';
import { ListSettingsType } from '../../reducers/common';

export enum OperationsActionType {
  Fetch = 'operations/fetch',
  FetchSuccess = 'operations/fetch_success',
  FetchError = 'operations/fetch_error',
  GenerateReportStarted = 'operations/generate_report_started',
  GenerateReportSuccess = 'operations/generate_report_success',
  GenerateReportError = 'operations/generate_report_error'
}

const OperationsActions = {
  fetch: ({ page, filters }: { page?: number; filters: GenericFilters }) =>
    createAction(OperationsActionType.Fetch, {
      pagination: {
        page: page || 1
        /* TODO: No funciona el endpoint enviando per_page. Consulté con Backend pero no tuve respuestas aún */
        /*per_page: Constants.SMALL_LIST_PAGE_SIZE*/
      },
      filters
    }),
  fetchSuccess: ({
    operations,
    settings
  }: {
    operations: Operations[];
    settings: ListSettingsType;
  }) => createAction(OperationsActionType.FetchSuccess, { operations, settings }),
  fetchError: (error: Error) => createErrorAction(OperationsActionType.FetchError, error),
  generateReport: ({ page, filters }: { page?: number; filters: GenericFilters }) =>
    createAction(OperationsActionType.GenerateReportStarted, {
      pagination: {
        page: page || 1
        /* TODO(francossegura): No funciona el endpoint enviando per_page. Consulté con Backend pero no tuve respuestas aún */
        /*per_page: Constants.SMALL_LIST_PAGE_SIZE*/
      },
      filters
    }),
  generateReportSuccess: () => createAction(OperationsActionType.GenerateReportSuccess),
  generateReportError: (error: Error) =>
    createErrorAction(OperationsActionType.GenerateReportError, error)
};

export type OperationsAction = ActionsType<typeof OperationsActions>;

export default OperationsActions;
